import { SelectOption, SortDirection } from '@gea/digital-ui-lib';
import { SORT_COLUMN } from '../state/organizations/organizations.comparator';
import { TreeNode } from 'primeng/api';

export interface MachineAndFaultDto {
  id: number;
  name: string;
  nameInCRM: string;
  equipmentType: string;
  omniId: string | undefined;
  faults: FaultDto[];
}

export interface MachineFaultDto {
  [key: string]: string | number | null | undefined;
  machineId: number;
  machineName: string;
  faultCode: number;
  faultName: string;
  countPending: number;
  countSolved: number;
  timeStamp: string;
  // Nullable solved timestamp returned by backend when fault has been resolved
  solved?: string | null;
  countPendingRelative?: number; // value between 0 and 1
}

export interface ResolutionCount {
  pending: number;
  solved: number;
}

export interface FaultAnalysisHistoryItem {
  timestamp: string;
  shutdowns: ResolutionCount;
  warnings: ResolutionCount;
}

export interface FaultAnalysisDto {
  machines: MachineAndFaultDto[];
  shutdowns: MachineFaultDto[];
  warnings: MachineFaultDto[];
  faultHistory: FaultAnalysisHistoryItem[];
}

export interface BaseFault {
  id: number;
  machineId: number;
  machineName: string;
  faultCode: number;
  faultName: string;
  countPending: number;
  countSolved: number;
  type?: 'warning' | 'shutdown';
  totalPending?: number;
}

export interface Annunciation extends MachineFaultDto {
  totalPending?: number;
}

export interface FaultDto {
  faultCode: number;
  faultCodeGroup: number;
  name: string;
  status: number;
}

export enum FaultStatus {
  PENDING = 'PENDING',
  SOLVED = 'SOLVED',
}
export interface FetchFaultCodesParams {
  machines: number[];
  dateRange?: number;
}

export const DEFAULT_FAULT_STATUS = [FaultStatus.PENDING];

export interface FetchFaultAnalysisParams extends FetchFaultCodesParams {
  faults?: number[];
  faultStatus?: FaultStatus[];
}

export interface SortAnnunciationsParams {
  columnName: SORT_COLUMN;
  sortOrder: SortDirection;
  annunciation: 'shutdowns' | 'warnings';
}

export interface FaultsStateModel {
  faultyMachines?: SelectOption<number>[];
  shutdowns?: MachineFaultDto[];
  warnings?: MachineFaultDto[];
  faultHistory?: FaultAnalysisHistoryItem[];
  faultCodeGroups?: SelectOption<number>[];
  faultCodes?: SelectOption[];
  selectedDateRange?: number;
  selectedFaultStatus?: FaultStatus[];
  selectedMachines?: number[];
  selectedFaults?: number[];
  isLoading?: boolean;
}

export type AnnunciationTree = TreeNode<MachineFaultDto>;
